import type {
	ExpansionOptionsQuery,
	ExpansionOptionsResponse
} from '~/core/entities/property';

import { extractErrorLogContext, useLogger } from '~/composables/useLogger';
import { nuxtPropertiesRepository } from '~~/adapters/repositories/nuxt';

function makeFallbackResponse(): ExpansionOptionsResponse {
	return { screen: 'automatic_expansion', options: [] };
}

export function useFetchShortsExpansionOptions() {
	const logger = useLogger('useFetchShortsExpansionOptions');
	const getCookieData = useCookieData();

	async function fetchExpansionOptions(
		filters: ExpansionOptionsQuery
	): Promise<ExpansionOptionsResponse> {
		const [result, error] = await nuxtPropertiesRepository.getExpansionOptions(
			filters,
			getCookieData()
		);

		if (error || !result) {
			logger.error('Failed to fetch Shorts expansion options', {
				...(error
					? extractErrorLogContext(error)
					: {
							error_message:
								'No expansion options result returned from repository'
						})
			});
			return makeFallbackResponse();
		}

		return result;
	}

	return { fetchExpansionOptions };
}
